const navbarOffset = 100,
    stickyMenuClass = "menu--sticky",
    openingUserNavClass = "user-nav--opening",
    userNavOpenClass = "user-nav--open",
    activeUserInfoClass = "user-info--active";

export default {

    handleDesktopScroll(scrollY, lastScrollY, $menu, $userNav, $userInfo) {

        $userNav.removeClass(userNavOpenClass);
        $userNav.removeClass(openingUserNavClass);
        $userInfo.removeClass(activeUserInfoClass);

        // send a scroll event to the sleekbar component
        let event = document.createEvent('Event');
        event.initEvent('closeSleekBarEvent', true, true);
        event.scrollOffset = scrollY - lastScrollY
        window.dispatchEvent(event);

        if (scrollY > lastScrollY && scrollY > navbarOffset && !$menu.hasClass(stickyMenuClass)) {
            $menu.addClass(stickyMenuClass);
        } else if (scrollY < lastScrollY && scrollY <= navbarOffset) {
            $menu.removeClass(stickyMenuClass);
        }
    }
}



// WEBPACK FOOTER //
// ./js/navbar/desktop/NavbarScroll.js